(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vhalam-size-guide')) {
    customElements.define('vhalam-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-size-guide-open]');
        if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.dialog.open) return;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
        }, options);
        this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow || '';
        }
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
